<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>


    <v-form lazy-validation @submit.prevent="updateProfile()" class="mt-3">

      <v-card flat>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap align-center>
              <v-flex xs12 sm12 md4>
                <div v-if="is_profil_edited" class="profile-image">
                  <v-avatar size="180px" class="avatar">
                    <img v-if="profile.avatar_url" :src="profile.avatar_url" alt="Avatar utilisateur">
                    <v-btn rounded icon small class="avatar-edit primary white--text text-capitalize"
                      @click="editAvatar()">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </v-avatar>
                </div>

                <div v-else>
                  <image-input v-model="avatar">
                    <div slot="activator">
                      <v-avatar size="180px" v-ripple v-if="!avatar" class="grey lighten-3 mb-3">
                        <span>Cliquez pour ajouter une image</span>
                      </v-avatar>
                      <v-avatar size="180px" v-ripple v-else class="mb-3">
                        <img :src="avatar.imageURL" alt="Avatar utilisateur">
                      </v-avatar>
                    </div>
                  </image-input>
                </div>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-subheader>Nom</v-subheader>
                <v-text-field v-model="profile.first_name" label="Nom" solo></v-text-field>

                <v-subheader>Prénom</v-subheader>
                <v-text-field v-model="profile.last_name" label="Prénom" solo></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-subheader>Pseudo</v-subheader>
                <v-text-field v-model="profile.username" label="Nom d'utilisateur" solo></v-text-field>

                <v-subheader>Téléphone</v-subheader>
                <v-text-field v-model="profile.phone" label="Téléphone" solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>


      <v-card class="mt-5" flat>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs6 sm4>
                <v-subheader>Pays</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="profile.country_id" :items="countries" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Pays requis']" label="Pays" clearable solo
                  @input="chooseDepartement()"></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Département</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="profile.department_id" :items="departments" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Département requis']" label="Département" clearable solo
                  @input="chooseMunicipality()"></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Commune</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="profile.municipality_id" :items="municipalities" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Commune requise']" label="Commune" clearable solo
                  @input="chooseDistrict()"></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Arrondissement</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="profile.district_id" :items="districts" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Arrondissement requis']" label="Arrondissement" clearable solo
                  @input="chooseTown()"></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Village</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="profile.town_id" :items="towns" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Village requis']" label="Village" clearable solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Adresse physique</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="profile.address" label="Adresse physique" solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Mot de passe</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="profile.password"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  :rules="[rules.required, rules.min]" :type="showPassword ? 'text' : 'password'" label="Mot de passe"
                  hint="Au moins 8 caractères" counter @click:append="showPassword = !showPassword" solo></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <br>

      <div class="text-center mt-1">
        <v-btn rounded color="primary" :loading="loading" :disabled="loading" type="submit">Enregistrer</v-btn>
      </div>

    </v-form>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions'
import ImageInput from '~/components/ImageInput.vue'

export default {
  name: 'settings-profile',
  mixins: [Permissions],

  components: {
    ImageInput: ImageInput
  },

  data: () => ({
    // profile: {},
    avatar: null,
    saved: false,

    is_profil_edited: true,

    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',
    profile: {},
    showPassword: true,
    rules: {
      required: value => !!value || 'Mot de passe requis.',
      // min: v => v.length >= 8 || 'Minimum 8 caractères',
    },
    loading: false
  }),

  computed: {
    countries() { return this.$store.getters.getCountries; },
    departments() { return this.$store.getters.getDepartments; },
    municipalities() { return this.$store.getters.getMunicipalities; },
    districts() { return this.$store.getters.getDistricts; },
    towns() { return this.$store.getters.getTowns; },
  },

  created() {
    this.$store.dispatch("loadCountries");
    // this.$store.dispatch("fetchDepartments");
    // this.$store.dispatch("fetchMunicipalities");
    // this.$store.dispatch("fetchDistricts");
    // this.$store.dispatch("fetchTowns");
    this.fetchUtilils();
  },


  watch: {
    avatar: {
      handler: function () {
        this.saved = false
      },
      deep: true
    }
  },

  methods: {
    async fetchUtilils() {
      await this.$store.dispatch("fetchUser");
      const item = JSON.parse(
        JSON.stringify(this.$store.getters.authUser)
      );
      if (item != null) {
        this.profile = item;
      }
    },

    editAvatar() {
      this.is_profil_edited = false;
    },


    updateProfile() {
      if (this.profile.first_name == null ||
        this.profile.last_name == null ||
        this.profile.username == null || this.profile.address == null) {
        this.snackbar = true;
        this.snackbar_color = 'error';
        this.snackbar_message = "Veuillez remplir tous les champs avant de sauvegarder";
        return;
      } else {
        if (this.profile.password != null && this.profile.password.length < 8) {
          this.snackbar = true;
          this.snackbar_color = 'error';
          this.snackbar_message = "Veuillez entrer au moins 8 caractères pour le mot de passe";
          return;
        }
        this.loading = true
        if (this.is_profil_edited == false) {
          // this.profile.avatar_url = this.avatar.imageURL;
          this.profile.avatar_url = this.avatar.imageFile;
        }

        this.$store.dispatch('updateUser', this.profile);

        this.snackbar_message = "Paramètres édités avec succès !";
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.is_profil_edited = true;
        this.loading = false

        if (this.$can('access dashboard')) {
          this.$router.push(this.$route.query.redirect || { name: 'overview' })
        } else {
          this.$router.push(
            this.$route.query.redirect || { name: 'about' }
          )
        }
        
        window.location.reload();
      }
    },

    chooseDepartement() {
      let pays = this.profile.country_id;
      this.$store.dispatch('loadDepartments', pays);
    },

    chooseMunicipality() {
      let departement = this.profile.department_id;
      this.$store.dispatch('loadMunicipalities', departement);
    },

    chooseDistrict() {
      let commune = this.profile.municipality_id;
      this.$store.dispatch('loadDistricts', commune);
    },

    chooseTown() {
      let arrond = this.profile.district_id;
      this.$store.dispatch('loadTowns', arrond);
    },
  }
}
</script>

<style scoped>
.profile-image {
  position: relative;
}

.profile-image .avatar-edit {
  position: absolute;
  bottom: 20px;
  left: 140px;
}

.profile-image .avatar {
  background: var(--bg-dash);
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/settings/profile.vue